function buildSelectionPreviewPictures(pictures, selections, activeClient) {
  const selectedIds = new Set();

  if (activeClient === 'aggregate') {
    selections.forEach(selection => {
      (selection.pictureIds || []).forEach(pictureId => selectedIds.add(String(pictureId)));
    });
  } else {
    const selection = selections.find(item => String(item.id) === String(activeClient));
    (selection?.pictureIds || []).forEach(pictureId => selectedIds.add(String(pictureId)));
  }

  return pictures.filter(picture => selectedIds.has(String(picture.id)));
}

function filterSelectionRecordPictures(pictures, selections, activeClient, selectedOnly) {
  if (!selectedOnly) return pictures;
  return buildSelectionPreviewPictures(pictures, selections, activeClient);
}

export { buildSelectionPreviewPictures, filterSelectionRecordPictures };
